import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Select } from '../../../components/Select/Select';
import { formatNumber } from '../../../core/helpers';
import PageLayout from '../../../wrappers/PageLayout';
import SellerSalesChart from './SellerSalesChart';
import './SellerSales.scss';
import SalesMetrics from './SalesMetrics';

export default function SellerSales() {
  const { t } = useTranslation();
  const [year, setYear] = useState<number>(2022);

  const onYearChange = (y: string | number) => {
    setYear(+y);
  };

  return (
    <PageLayout
      className='flex-grow-1'
      rightColumn={
        <div style={{ maxWidth: 328 }} className='ms-lg-auto pt-3 pt-lg-0'>
          <div className='Paper pb-4 pt-2 px-3'>
            <div className='fw-600'>{t('Units sold this year')}</div>
            <div className='Text--30 fw-900 mb-3'>21,439</div>
            <div className='fw-600'>{t('Revenue this year')}</div>
            <div className='Text--30 fw-900 mb-3'>
              {formatNumber(total / 100, {
                currency: 'eur',
              })}
            </div>
          </div>
        </div>
      }
    >
      <div className='Paper px-4 pt-3 pb-4'>
        <div className='d-flex align-items-center justify-content-between mb-2'>
          <div className='Text--30 fw-900'>{t('Sales')}</div>
          <div>
            <Select
              size='sm'
              name='year'
              value={year}
              placeholder='Select'
              options={[
                {
                  name: '2022',
                  id: 2022,
                },
              ]}
              onChange={onYearChange}
              className='pb-0 Select--SellerSales'
            />
          </div>
        </div>
        <SellerSalesChart sales={sales} />
        <div
          className='SellerSales__separator mx-n4 mb-3'
          style={{
            marginTop: 32,
          }}
        />
        <SalesMetrics />
        <div
          className='SellerSales__separator mx-n4 mb-2'
          style={{
            marginTop: 32,
          }}
        />
        <div className='d-flex align-items-center justify-content-between mb-2'>
          <div className='Text--20 fw-800'>{t('Sales by marketplace')}</div>
          <div>
            <Select
              size='sm'
              name='year'
              value={year}
              placeholder='Select'
              options={[
                {
                  name: '2022',
                  id: 2022,
                },
              ]}
              onChange={onYearChange}
              className='pb-0 Select--SellerSales'
            />
          </div>
        </div>
        <div
          className='row mx-0'
          style={{
            marginBottom: 6,
          }}
        >
          <div className='col-3 Text--gray ps-0'>{t('Marketplace')}</div>
          <div className='col Text--gray'>{t('To')}</div>
          <div className='col Text--gray pe-0'>{t('Amount')}</div>
        </div>
        {SALES_BY_MARKETPLACE.map((s) => (
          <div className='row mx-0 border-top pt-2' key={s.marketplace}>
            <div className='col-3 ps-0'>{t(s.marketplace)}</div>
            <div className='col'>
              {s.items.map((i) => (
                <div className='mb-2' key={i.country}>
                  {t(i.country)}
                </div>
              ))}
            </div>
            <div className='col pe-0'>
              {s.items.map((i) => (
                <div className='mb-2' key={i.country}>
                  {formatNumber(i.amount / 100, {
                    currency: 'eur',
                  })}
                </div>
              ))}
            </div>
          </div>
        ))}
        <div
          className='SellerSales__separator mx-n4 mb-2'
          style={{
            marginTop: 32,
          }}
        />
        <div className='Text--20 fw-800 mb-3'>{t('Top-Selling SKUs')}</div>

        <div
          className='row mx-0'
          style={{
            marginBottom: 6,
          }}
        >
          <div className='col-3 Text--gray ps-0'>{t('Marketplace')}</div>
          <div className='col Text--gray'>{t('Product')}</div>
          <div className='col-2 Text--gray pe-0'>{t('Items sold')}</div>
        </div>
        {SKU.map((s) => (
          <div className='row mx-0 border-top pt-2' key={s.marketplace}>
            <div className='col-3 ps-0'>{t(s.marketplace)}</div>
            <div className='col text-truncate'>
              {s.items.map((item, i) => (
                <div className='mb-2 text-truncate' key={i}>
                  {t(item.name)}
                </div>
              ))}
            </div>
            <div className='col-2 pe-0'>
              {s.items.map((item, i) => (
                <div className='mb-2' key={i}>
                  {formatNumber(item.amount / 100, {
                    currency: 'eur',
                  })}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </PageLayout>
  );
}
const sales = [
  {
    country: 'DE',
    amount: 4000000,
    date: new Date(2022, 0, 1),
  },
  {
    country: 'ES',
    amount: 4000000,
    date: new Date(2022, 0, 1),
  },
  {
    country: 'GB',
    amount: 3400000,
    date: new Date(2022, 0, 1),
  },
  {
    country: 'PL',
    amount: 2200000,
    date: new Date(2022, 0, 1),
  },
  {
    country: 'DE',
    amount: 1100000,
    date: new Date(2022, 1, 1),
  },
  {
    country: 'ES',
    amount: 900000,
    date: new Date(2022, 1, 1),
  },
  {
    country: 'GB',
    amount: 4000000,
    date: new Date(2022, 1, 1),
  },
  {
    country: 'PL',
    amount: 3200000,
    date: new Date(2022, 1, 1),
  },
  {
    country: 'DE',
    amount: 1200000,
    date: new Date(2022, 2, 1),
  },
  {
    country: 'ES',
    amount: 4000000,
    date: new Date(2022, 2, 1),
  },
  {
    country: 'GB',
    amount: 2300000,
    date: new Date(2022, 2, 1),
  },
  {
    country: 'PL',
    amount: 1400000,
    date: new Date(2022, 2, 1),
  },
  {
    country: 'DE',
    amount: 2400000,
    date: new Date(2022, 3, 1),
  },
  {
    country: 'ES',
    amount: 5400000,
    date: new Date(2022, 3, 1),
  },
  {
    country: 'GB',
    amount: 4000000,
    date: new Date(2022, 3, 1),
  },
  {
    country: 'PL',
    amount: 3000000,
    date: new Date(2022, 3, 1),
  },
  {
    country: 'DE',
    amount: 2000000,
    date: new Date(2022, 4, 1),
  },
  {
    country: 'ES',
    amount: 1000000,
    date: new Date(2022, 4, 1),
  },
  {
    country: 'GB',
    amount: 1800000,
    date: new Date(2022, 4, 1),
  },
  {
    country: 'PL',
    amount: 4400000,
    date: new Date(2022, 4, 1),
  },
  {
    country: 'DE',
    amount: 1400000,
    date: new Date(2022, 5, 1),
  },
  {
    country: 'ES',
    amount: 1200000,
    date: new Date(2022, 5, 1),
  },
  {
    country: 'GB',
    amount: 5000000,
    date: new Date(2022, 5, 1),
  },
  {
    country: 'PL',
    amount: 4000000,
    date: new Date(2022, 5, 1),
  },
  {
    country: 'DE',
    amount: 2500000,
    date: new Date(2022, 6, 1),
  },
  {
    country: 'ES',
    amount: 1400000,
    date: new Date(2022, 6, 1),
  },
  {
    country: 'GB',
    amount: 2400000,
    date: new Date(2022, 6, 1),
  },
  {
    country: 'PL',
    amount: 3000000,
    date: new Date(2022, 6, 1),
  },
];

const total = sales.reduce((acc, i) => {
  return (acc += i.amount);
}, 0);

const SALES_BY_MARKETPLACE = [
  {
    marketplace: 'amazon.de',
    items: [
      { country: 'FR', amount: 4849000 },
      { country: 'AT', amount: 2249000 },
      { country: 'DK', amount: 1093000 },
      { country: 'LU', amount: 893000 },
    ],
  },
  {
    marketplace: 'amazon.es',
    items: [
      { country: 'PT', amount: 3229300 },
      { country: 'FR', amount: 2032900 },
      { country: 'GB', amount: 80000 },
    ],
  },
  {
    marketplace: 'amazon.uk',
    items: [
      { country: 'IE', amount: 4429100 },
      { country: 'DK', amount: 1249200 },
    ],
  },
  {
    marketplace: 'amazon.pl',
    items: [
      { country: 'CZ', amount: 1249000 },
      { country: 'AT', amount: 300101 },
    ],
  },
];

const SKU = [
  {
    marketplace: 'amazon.de',
    items: [
      {
        name: '3930 Corelle Everyday Expressions 12-pc Dinnerwa...',
        amount: 12493,
      },
      {
        name: '2310 JoyJolt Savor Double Wall Insulated Glasses E...',
        amount: 12002,
      },
      {
        name: '1929 Swedish Wholesale Swedish Dish Cloths - 10...',
        amount: 10230,
      },
      {
        name: '2392 HIWARE 48-Piece Silverware Set with Steak K...',
        amount: 101019,
      },
      {
        name: '19200 4 Pack Ice Cube Trays, Ice Tray Durable & F...',
        amount: 9231,
      },
    ],
  },
  {
    marketplace: 'amazon.es',
    items: [
      {
        name: '19200 4 Pack Ice Cube Trays, Ice Tray Durable & F...',
        amount: 44439,
      },
      { name: '2411 NumNum Pre-Spoon GOOtensils | Baby Spoon', amount: 5919 },
      {
        name: '1041 Swedish Wholesale Swedish Dish Cloths - 10...',
        amount: 3599,
      },
      {
        name: '2392 HIWARE 48-Piece Silverware Set with Steak K...',
        amount: 2044,
      },
      {
        name: '19200 4 Pack Ice Cube Trays, Ice Tray Durable & F...',
        amount: 2001,
      },
    ],
  },
  {
    marketplace: 'amazon.uk',
    items: [
      {
        name: '3930 Corelle Everyday Expressions 12-pc Dinnerwa...',
        amount: 2439,
      },
      {
        name: '2310 JoyJolt Savor Double Wall Insulated Glasses E...',
        amount: 10002,
      },
      {
        name: '1929 Swedish Wholesale Swedish Dish Cloths - 10...',
        amount: 1230,
      },
      {
        name: '19200 4 Pack Ice Cube Trays, Ice Tray Durable & F...',
        amount: 1230,
      },
      {
        name: '19200 4 Pack Ice Cube Trays, Ice Tray Durable & F...',
        amount: 1230,
      },
    ],
  },
  {
    marketplace: 'amazon.pl',
    items: [
      {
        name: '3930 Corelle Everyday Expressions 12-pc Dinnerwa...',
        amount: 10400,
      },
      {
        name: '2310 JoyJolt Savor Double Wall Insulated Glasses E...',
        amount: 10394,
      },
      {
        name: '1929 Swedish Wholesale Swedish Dish Cloths - 10...',
        amount: 1249,
      },
      {
        name: '2392 HIWARE 48-Piece Silverware Set with Steak K...',
        amount: 1233,
      },
      {
        name: '19200 4 Pack Ice Cube Trays, Ice Tray Durable & F...',
        amount: 1222,
      },
    ],
  },
];
